import { DataSource } from '@angular/cdk/table';
import { Observable } from 'rxjs';
import { SchoolsService } from './schools.service';

export class SchoolsDataSource extends DataSource<any> {
  constructor(private schoolsService: SchoolsService) {
    super();
  }

  connect(): Observable<any[]> {
    return this.schoolsService.getSchools();
  }

  override disconnect(): void {
    // throw new Error('Method not implemented.');
  }
}
